import {
  CURRENT_SONG_INDEX,
  CURRENT_SONG_LIST,
  LOADED,
  MAX_RANGE,
  NEW_SONG,
  ONCHANGE_LOADED,
  PLAY,
  RANGE,
  VOLUME,
} from "../types/player";
import blackPink from "../../media/images/black-pink1.jpg";
import hylt from "../../media/audio/hylt.mp3";
import { topSongsData } from "../../pages/Explore/TopSongs/topSongsData";

const initialState = {
  currentSongList: topSongsData,
  currentSong: {
    name: "How You Like That",
    artist: "Black Pink",
    duration: "3:28",
    img: blackPink,
    audio: hylt,
    color: "99, 22, 55",
    video:
      "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/BLACKPINK%20-%20'How%20You%20Like%20That'%20M_V-ioNng23DkIM.mp4?alt=media&token=36c73c4b-e036-49ab-a342-bfeda81a1bb0",
  },
  currentSongIndex: 0,
  maxRange: 0,
  range: 0,
  play: false,
  loaded: false,
  onChangeLoaded: false,
  volume: 0.5,
};

const playerReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case NEW_SONG:
      return { ...state, currentSong: payload };
    case MAX_RANGE:
      return { ...state, maxRange: payload };
    case RANGE:
      return { ...state, range: payload };
    case PLAY:
      return { ...state, play: payload };
    case LOADED:
      return { ...state, loaded: payload };
    case ONCHANGE_LOADED:
      return { ...state, onChangeLoaded: payload };
    case VOLUME:
      return { ...state, volume: payload };
    case CURRENT_SONG_INDEX:
      return { ...state, currentSongIndex: payload };
    case CURRENT_SONG_LIST:
      return { ...state, currentSongList: payload };
    default:
      return state;
  }
};

export default playerReducer;
